import type { SectionStatus } from '../../types/canvas';

const STATUS_CLASSES: Record<SectionStatus, string> = {
  generating: 'border-[1.5px] border-border animate-pulse',
  generated: 'border-[1.5px] border-border',
  approved: 'bg-success border-success',
  failed: 'bg-destructive border-destructive',
};

export function StatusDot({ status }: { status: SectionStatus }) {
  return (
    <span
      className={`inline-block w-2 h-2 rounded-full flex-shrink-0 ${STATUS_CLASSES[status]}`}
      aria-label={status}
    />
  );
}
